// Revise ▸ Checks: the manuscript in passes — a chapter as it reads with what the checks found underlined, the findings
// in the margin, the passes and their checks in the column.
export { ChecksPage as component, ChecksColumn as column, ChecksControls as headerControls } from '../../views/revise/ChecksPage.tsx';
export const room = 'revise';
export const page = 'checks';
export const title = 'Checks';
export const help = 'cleanup';
export const columnTitle = 'Checks';
